import React from 'react';

//Variables auxiliares:
let executionTimeInteval = 20000;

class RealtimeSynchronizer extends React.Component {

    constructor() {
        super();

        this.state = {
            downloadSources: []
        }
    }

    componentDidMount() {
        this.setState({ downloadSources: this.props.downloadSources });
        this.interval = setInterval(() => this.executeTask(), executionTimeInteval);
    }

    render() {
        return (
            <React.Fragment />
        );
    }
    
    componentWillUnmount(){
        clearInterval(this.interval);
    }

    //Operative methods for asynchronous tasks:
    executeTask = () => {
        if (this.props.functionToBeExecuted !== undefined) {
            // console.log("...");
            this.props.functionToBeExecuted(false);
        }
    }
}

export default RealtimeSynchronizer;